import React, { memo } from 'react';
import Translate from '@client/components/shared/translation/Translate';
import {
    Button,
    ButtonType,
    ButtonColor,
} from '@pegasus/ui-components/components/button';
import { Text, TextPreset } from '@pegasus/ui-components/components/text';

interface DoiSuccessResendLinkProps {
    isLoading?: boolean;
    onClick: () => void;
}

const DoiSuccessResendLink = memo(
    ({ isLoading = false, onClick }: DoiSuccessResendLinkProps) => {
        return isLoading ? (
            <Text preset={TextPreset.S}>
                <Translate message="sending" />
            </Text>
        ) : (
            <Button
                buttonType={ButtonType.tertiary}
                fullWidth
                color={ButtonColor.dark}
                onClick={onClick}
                loading={isLoading}
            >
                <Translate message="resendEmail" />
            </Button>
        );
    },
);

export default DoiSuccessResendLink;
